import BAApi from './_baApi';

class BATransferAPI extends BAApi {
  constructor() {
    super();
  }
  controllerName = 'BATransfers';
}

export default new BATransferAPI();
